import CommunicationPreferences from './CommunicationPreferences'
export default CommunicationPreferences
